import { Column, Entity, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { PaperMergeChildEntity } from "./paper-merge-child.entity";

@Entity({ name: 'paper_merge' })
export class PaperMergeEntity {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column("int", { name: "no_of_parts" })
    noOfParts: number;

    @Column("int", { name: "class_id" })
    classId: number;

    @Column("varchar", { name: "paper_name" })
    paperName: string;

    @OneToMany(() => PaperMergeChildEntity, (mergeChild) => mergeChild.paperMergeId, { cascade: true })
    paperMergeChild: PaperMergeChildEntity[]
}  